<!--
 * @Description: 个人中心
 * @Author: xu wei
 * @Date: 2020-03-07 15:43:10
 * @LastEditTime: 2020-06-23 18:08:56
 * @LastEditors: gao shuai
 -->
<template>
  <div class="partinstall">
    <div class="bg_fff pdb25">
      <div class="gs_listcontainer">
        <p class="tip_red">基本资料</p>
        <!-- <dl class="clearfix">
          <dt>昵称</dt>
          <dd> {{baseInfo.name}}</dd>
        </dl> -->
        <dl class="clearfix">
          <dt>域名</dt>
          <dd>{{baseInfo.domain}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>账号</dt>
          <dd>{{baseInfo.account}} </dd>
        </dl>
        <dl class="clearfix">
          <dt>结算类型</dt>
          <dd>{{'T+'+baseInfo.type}}</dd>
        </dl>
        <dl class="clearfix">
          <dt> 联系ＱＱ </dt>
          <dd>{{baseInfo.linkQQ}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>联系电话</dt>
          <dd>{{baseInfo.linkphone}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>注册时间</dt>
          <dd>{{baseInfo.registerTime}}</dd>
        </dl>
      </div>
      <div class="gs_listcontainer mgt10" v-if="accountInfo.bank">
        <p class="tip_red">分账银行</p>
        <dl class="clearfix">
          <dt>开户银行</dt>
          <dd> {{accountInfo.bank}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>银行帐号</dt>
          <!-- <dd>{{accountInfo.bankcard}} <i class="el-icon-view iconeye" :class="{'on':accountInfo.eyeflag}" @click="seeaccount"></i></dd> -->
          <dd>{{accountInfo.bankcard}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>收款人</dt>
          <!-- <dd>{{accountInfo.userName}} <i class="el-icon-view iconeye" :class="{'on':accountInfo.eyeflag}" @click="seeaccount"></i></dd> -->
          <dd>{{accountInfo.userName}}</dd>
        </dl>
        <dl class="clearfix">
          <dt> 所在地区 </dt>
          <dd>{{accountInfo.location}}</dd>
        </dl>
      </div>
    </div>
    <!-- 二级密码的确认 -->
    <el-dialog title="提示" :visible.sync="dialog.show" @close="dialog.secondPassword=''" custom-class="gs_dialog" width="400px">
      <div class="passwordBox">
        <span class="tit">二级密码：</span>
        <div class="inputBox">
          <el-input style="width:220px;" type="password" size="small" v-model="dialog.secondPassword" placeholder="请输入二级密码"></el-input>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button size="small" type="primary" @click="sureSeeaccount">确定</el-button>
        <el-button size="small" type="info" @click="dialog.show=false">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseInfo: {
        name: '', // 昵称
        account: '', // 账号
        type: '', // 结算类型
        linkQQ: '', // 联系qq
        linkphone: '', // 联系电话
        registerTime: '', // 注册时间
        domain: ''
      },
      accountInfo: {
        bank: '', // 开户银行
        userName: '', // 开户人
        bankcard: '', // 银行卡号
        location: '', // 所在地区
        eyeflag: false // 帐号的显隐
      },
      dialog: {
        show: false,
        secondPassword: ''
      }
    };
  },
  methods: {
    // 获取用户信息
    getUser() {
      this.$api.home
        .getUserinfo()
        .then((data) => {
          this.baseInfo.name = data.data.nickname;
          this.baseInfo.account = data.data.userName;
          this.baseInfo.type = data.data.settlementType;
          this.baseInfo.linkQQ = data.data.qqNumber;
          this.baseInfo.linkphone = data.data.phoneNumber;
          this.baseInfo.registerTime = data.data.joinDate;
          this.baseInfo.lastLogin = data.data.finalDate;
          this.baseInfo.domain = data.data.domain;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取用户银行信息
    getBankInfo() {
      this.$api.personCenter
        .bankInfo()
        .then((data) => {
          this.accountInfo.bank = data.data.bankName;
          this.accountInfo.userName = data.data.realName;
          this.accountInfo.bankcard = data.data.bankNumber;
          this.accountInfo.location = data.data.bankBranch;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 查看帐号信息
    seeaccount() {
      if (this.accountInfo.eyeflag) {
        this.accountInfo.eyeflag = false;
        this.getBankInfo();
      } else {
        this.dialog.show = true;
      }
    },
    // 输入二级密码后确认
    sureSeeaccount() {
      if (this.dialog.secondPassword === '') {
        this.$messageError('请输入二级密码！');
        return;
      }
      this.$api.personCenter
        .bankDetail({
          password: this.dialog.secondPassword
        })
        .then((data) => {
          if (data.status === 200) {
            this.accountInfo.bank = data.data.bankName;
            this.accountInfo.userName = data.data.realName;
            this.accountInfo.bankcard = data.data.bankNumber;
            this.accountInfo.location = data.data.bankBranch;
            this.accountInfo.eyeflag = true;
            this.dialog.show = false;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getUser();
    this.getBankInfo();
  }
};
</script>

<style lang="scss" scoped>
.tip_red {
  color: #3c8dbc;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 15px;
}
.gs_listcontainer {
  padding-top: 0;
  padding-bottom: 1px;
  margin-left: 20px;
  .clearfix {
    border: 1px solid #d9edf7;
    width: 95%;
    margin-bottom: 1px;
    padding-left: 0px;
    .mgl20 {
      float: right;
    }
    dt {
      background-color: #d9edf7;
      padding-right: 10px;
    }
    dd {
      padding-top: 5px;
    }
  }
}
.iconeye {
  cursor: pointer;
  margin-left: 10px;
  &.on {
    color: #63aafa;
  }
}
.passwordBox {
  padding-left: 20px;
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 16px;
  .tit {
    display: block;
    width: 100px;
    height: 32px;
    line-height: 32px;
  }
}
</style>
